import { render } from "./EditBox.vue?vue&type=template&id=4aaaaad4&scoped=true&ts=true"
import script from "./EditBox.vue?vue&type=script&lang=ts"
export * from "./EditBox.vue?vue&type=script&lang=ts"

import "./EditBox.vue?vue&type=style&index=0&id=4aaaaad4&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaaaad4"]])

export default __exports__